import { addPxSuffix } from '@/src/helpers';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

type Props = {
  $disabled?: boolean;
  $fullWidth?: boolean;
  $margin?: string | number;
};

const LinkCss = css<Props>`
  text-decoration: none;
  margin: ${({ $margin }) => addPxSuffix($margin || '0')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'max-content')};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    transition: all 0.2s ease-in-out;

    &:hover {
      opacity: 0.7;
    }
  }
`;

const Button = styled.button<Props>`
  ${LinkCss}
`;

const InternalLink = styled(Link)<Props>`
  ${LinkCss}
`;

const ExternalLink = styled.a<Props>`
  ${LinkCss}
`;

const S = {
  Button,
  InternalLink,
  ExternalLink,
};

export default S;
